import React from "react";
import { styled, makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
// import { TaskIcon } from "@mui/icons-material";
import "./Chart.css";
import {
  Button,
  Container,
  Typography,
  Card,
  CardActions,
  CardContent,
} from "@material-ui/core";
import RevenueYTD from "./RevenueYTD";
import Conversion from "./Conversion";
import Map from "./Map";
import TopCustomer from "./TopCustomer";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  borderRadius: "12px",
  boxShadow: "0px 4px 20px rgba(238, 238, 238, 0.501967)",
  paddingBottom: "35px",
  height: "350px",
}));
const useStyles = makeStyles((theme) => ({
  footerSubTitle: {
    fontSize: "0.8rem",
    cursor: "pointer",
    color: "#2B2D33",
  },
  cardBox: {
    boxShadow: "0px 4px 20px rgba(238, 238, 238, 0.501967)",
    padding: "10px",
    background: "#fff",
    borderRadius: "10px",
  },
  cardTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "20px",
  },
  summery: {
    fontSize: "1rem",
    fontWeight: "normal",
  },
  card: {
    background: "#FFF4DE",
    boxShadow: "none",
  },
  card2: {
    background: "#F3E8FF",
    boxShadow: "none",
  },
  card3: {
    background: "#70C65470",
    boxShadow: "none",
  },
  cardIcon: {
    width: "40px",
    height: "40px",
    lineHeight: "55px",
    color: "#fff",
    textAlign: "center",
    borderRadius: "50%",
    background: "#FF947A",
  },
  cardIcon2: {
    width: "40px",
    height: "40px",
    lineHeight: "55px",
    color: "#fff",
    textAlign: "center",
    borderRadius: "50%",
    background: "#BF83FF",
  },
  cardIcon3: {
    width: "40px",
    height: "40px",
    lineHeight: "55px",
    color: "#fff",
    textAlign: "center",
    borderRadius: "50%",
    background: "#70C654",
  },
  cardSubTitle: {
    fontSize: "1.5rem",
    color: "#111",
    fontWeight: "700",
  },
  cardSubTitle2: {
    fontSize: "1rem",
    fontWeight: "500",
  },
  exportBtn: {
    fontWeight: "600",
  },
}));
const Chart = ({ isShaws }) => {
  const classes = useStyles();
  return (
    <div className={isShaws ? "chart" : "chart2"}>
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={1}
            className={classes.salesSummery}
            style={{ marginTop: "20px" }}
          >
            <Grid item xs={12} lg={7} md={12}>
              <Item>
                <Box className={classes.cardTitle} sx={{ pb: 3 }}>
                  <Box>
                    <Typography variant="h5" className="adminHomeTitle">
                      Monthly Sales
                    </Typography>
                    <Typography variant="h6" className={classes.summery}>
                      Sales Summery
                    </Typography>
                  </Box>{" "}
                  <Box>
                    <Button variant="outlined" className={classes.exportBtn}>
                      <span className="saveIcon">
                        {" "}
                        <SaveAltIcon />
                      </span>
                      Export
                    </Button>
                  </Box>
                </Box>
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={4} md={12}>
                    <Box>
                      <Card className={classes.card}>
                        <CardContent>
                          <Typography
                            sx={{ fontSize: 14 }}
                            color="text.secondary"
                            gutterBottom
                            className={classes.cardIcon}
                          >
                            <TextSnippetIcon className={classes.icon} />
                          </Typography>

                          <Typography
                            sx={{ mb: 1.5 }}
                            className={classes.cardSubTitle}
                          >
                            53
                          </Typography>
                          <Typography
                            sx={{ mb: 1.5 }}
                            color="text.secondary"
                            className={classes.cardSubTitle2}
                          >
                            RFQ
                          </Typography>
                        </CardContent>
                      </Card>
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={4} md={12}>
                    <Box>
                      <Card className={classes.card2}>
                        <CardContent>
                          <Typography
                            sx={{ fontSize: 14 }}
                            color="text.secondary"
                            gutterBottom
                            className={classes.cardIcon2}
                          >
                            <PersonAddAltIcon className={classes.icon} />
                          </Typography>

                          <Typography
                            sx={{ mb: 1.5 }}
                            className={classes.cardSubTitle}
                          >
                            9
                          </Typography>
                          <Typography
                            sx={{ mb: 1.5 }}
                            color="text.secondary"
                            className={classes.cardSubTitle2}
                          >
                            New Customers
                          </Typography>
                        </CardContent>
                      </Card>
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={4} md={12}>
                    <Box>
                      <Card className={classes.card3}>
                        <CardContent>
                          <Typography
                            sx={{ fontSize: 14 }}
                            color="text.secondary"
                            gutterBottom
                            className={classes.cardIcon3}
                          >
                            <PersonAddAltIcon className={classes.icon} />
                          </Typography>

                          <Typography
                            sx={{ mb: 1.5 }}
                            className={classes.cardSubTitle}
                          >
                            36
                          </Typography>
                          <Typography
                            sx={{ mb: 1.5 }}
                            color="text.secondary"
                            className={classes.cardSubTitle2}
                          >
                            Quotes
                          </Typography>
                        </CardContent>
                      </Card>
                    </Box>
                  </Grid>
                </Grid>
              </Item>
            </Grid>
            <Grid item xs={12} lg={5} md={12}>
              <Item>
                <RevenueYTD />
              </Item>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={1}
            className={classes.salesSummery}
            style={{ paddingTop: "20px" }}
          >
            <Grid item xs={12} lg={7} md={12}>
              <Box className={classes.cardBox}>
                <Conversion />
              </Box>
            </Grid>
            <Grid item xs={12} lg={5} md={12}>
              <Box className={classes.cardBox}>
                <Map />
              </Box>
            </Grid>
            <Grid
              container
              spacing={1}
              className={classes.salesSummery}
              style={{ padding: "20px 0" }}
            >
              {" "}
              <Grid item xs={12} lg={7} md={12}>
                <Box className={classes.cardBox}>
                  <TopCustomer />
                </Box>
              </Grid>
              <Grid item xs={12} lg={5} md={12}>
                <Box></Box>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

export default Chart;
